import { render, staticRenderFns } from "./EditFlagModal.vue?vue&type=template&id=87b30450&scoped=true&"
import script from "./EditFlagModal.vue?vue&type=script&lang=ts&"
export * from "./EditFlagModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditFlagModal.vue?vue&type=style&index=0&id=87b30450&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b30450",
  null
  
)

export default component.exports